import { render } from "./StationPassportChanges.vue?vue&type=template&id=5cc6c3d4"
import script from "./StationPassportChanges.vue?vue&type=script&lang=js"
export * from "./StationPassportChanges.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__